import React from "react";
import withRoot from "withRoot";
import PropTypes from "prop-types";
// @material-ui components
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grow from "@material-ui/core/Grow";
import Slide from "@material-ui/core/Slide";
// custom components
import MainLayout from "layout/MainLayout.jsx";
// custom icons
import LogoIcon from "components/Icons/Logo.jsx";
// jss
import styles from "assets/jss/views/styleHomePage.jsx";

class HomePage extends React.Component {
  constructor(props) {
    super(props);
  }

  render = () => {
    const { classes } = this.props;

    return (
      <MainLayout>
        <div>
          <Grow in={true}>
            <LogoIcon className={classes.mainLogo} />
          </Grow>
          <div>
            <div className={classes.textArea}>
              <Slide direction="right" in={true}>
                <Typography variant="h2" gutterBottom={true}>
                  Who is really winning the race?
                </Typography>
              </Slide>
              <Slide direction="right" in={true}>
                <Typography variant="h4">
                  カスタマーと共に勝者になるために。
                </Typography>
              </Slide>
            </div>
          </div>
        </div>
      </MainLayout>
    );
  };
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRoot(withStyles(styles)(HomePage));
